import { render, staticRenderFns } from "./SearchShowAllOrders.vue?vue&type=template&id=4d5c1016&scoped=true"
import script from "./SearchShowAllOrders.vue?vue&type=script&lang=js"
export * from "./SearchShowAllOrders.vue?vue&type=script&lang=js"
import style0 from "./SearchShowAllOrders.vue?vue&type=style&index=0&id=4d5c1016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c1016",
  null
  
)

export default component.exports